
  import JobsFilter from '@/mixins/JobsFilter';
  import clearableTabIndex from '@/mixins/clearableTabIndex';
  import ModelItems from '@/mixins/ModelItems';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    name: 'JobBoxFilterMobile',
    mixins: [clearableTabIndex, ModelItems, JobsFilter, ScreenSize],
    props: {
      filterParams: {
        type: String,
        required: false,
        default: undefined,
      },
      useFacets: {
        type: Boolean,
        required: false,
        default: false,
      },
      facets: {
        type: Object,
        required: false,
        default: undefined,
      },
    },
  };
